import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrlApi } from "../../proxy";

export const getPalms = createAsyncThunk("palm/getPalms", async () => {
  try {
    const response = await axios.get(`${baseUrlApi}palm`);
    return response?.data;
  } catch (error) {
    throw error;
  }
});
